import { useEffect, useState } from "react";

/**
 *The `sanitizeMediaQueryString` is an optional parameter which is used to split `"@media "` from the mediaQuery if it
 *is needed. Its default value is `false`.
 * @param {string} mediaQuery
 * @param {boolean} sanitizeMediaQueryString
 * @returns boolean
 */
const useMediaQuery = (mediaQuery: string, sanitizeMediaQueryString = false) => {
  const dynamicMediaQuery = sanitizeMediaQueryString ? mediaQuery.split("@media ")[1] : mediaQuery;
  const [isVerified, setIsVerified] = useState(!!window.matchMedia(dynamicMediaQuery).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(dynamicMediaQuery);
    const documentChangeHandler = () => setIsVerified(!!mediaQueryList.matches);

    mediaQueryList.addListener(documentChangeHandler);

    documentChangeHandler();
    return () => {
      mediaQueryList.removeListener(documentChangeHandler);
    };
  }, [dynamicMediaQuery]);

  return isVerified;
};

export default useMediaQuery;
